import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://atopvinhrlicujtwltsg.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF0b3B2aW5ocmxpY3VqdHdsdHNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg5MTM1MTcsImV4cCI6MjA3NDQ4OTUxN30.7vTPZ-rgZh10HqOdn1dJf-_wRbWuVBPJev02TA7_VTQ'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
